import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { TIPO_PLAN_CORPORATIVO_CHOICE } from "../interfaces";
import { cellNotFilter, emptyCell, formatDate } from "../utils";
import { EstadoComponente } from "../components/ui";
import { Button } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import { useInfoCoordenadasStore } from "../components/ui/InfoCoordendas/useInfoCoordendas.store";
import { IFactibilidadCorporativo } from "../interfaces/erp/factibilidad_corporativo";
import { EstadoFactibilidadCorporativaENUM } from "../constants";

type UseTableColumnsFactibilidadCorporativaOptions = {
  hideEstadoFactibilidad?: boolean
}

export const useTableColumnsFactibilidadCorporativa = (
  options: UseTableColumnsFactibilidadCorporativaOptions = {}
) => {

  const { hideEstadoFactibilidad = false } = options
  const infoCoordendas = useInfoCoordenadasStore()

  const columnsFactibilidad = useMemo<MRT_ColumnDef<IFactibilidadCorporativo>[]>(() => {
    const cols: MRT_ColumnDef<IFactibilidadCorporativo>[] = [
    {
      accessorKey: 'numero_seguimiento',
      header: 'Número de Seguimiento',
      Cell: ({ row }) => row.original?.preventa_corporativa_data?.numero_seguimiento || "N/A",
      enableColumnFilter: true,
      //enablePinning:true
    },
    {
      accessorKey: 'identificacion',
      header: 'identificacion',
      Cell: ({ row }) => `${row.original.prospecto_corporativo_data?.identificacion}`
    },
    {
      accessorKey: 'razon_social',
      header: 'razon social',
      Cell: ({ row }) => `${row.original.prospecto_corporativo_data?.razon_social}`
    },
    {
      accessorKey: 'nombre_personalizado',
      header: 'nombre enlace',
      Cell: ({ row }) => {
        const nombreBase = row.original?.preventa_corporativa_data?.data_plan_personalizado?.nombre_personalizado;
        if (!nombreBase) return "N/A";
        return row.original?.es_backup ? `${nombreBase}_BACKUP` : nombreBase;
      },
      enableColumnFilter: true,
    },
    {
      ...cellNotFilter,
      accessorKey: 'estado_factibilidad',
      header: 'estado factibilidad',
      size: 150,
      Cell: ({ row }) => {
        const estado = row.original.estado_factibilidad
        if (!estado) return null;
        const esAprabado = estado === EstadoFactibilidadCorporativaENUM.APROBADO;
        return (
          <EstadoComponente
            backgroundColor={esAprabado ? 'green' : 'blue'}
            texto={estado}
          />
        )
      }
      /* row.original.estado_factibilidad != null ?
        <EstadoComponente backgroundColor={'blue'
        } texto={row.original.estado_factibilidad} /> : null */
      ,
    },
    {
      accessorKey: 'fecha_creacion',
      enableColumnFilter: false,
      header: 'fecha creacion',
      Cell: ({ row }) => formatDate(row.original.fecha_creacion)
    },
    {
      accessorKey: 'fecha_inspeccion',
      enableColumnFilter: false,
      header: 'fecha inspeccion',
      Cell: ({ row }) => row.original.fecha_inspeccion ? formatDate(row.original.fecha_inspeccion) : "N/A"
    },

    ///* Preventa corporativa
    // {
    //   ...cellNotFilter,
    //   accessorKey: 'es_demo',
    //   header: 'Es demo',
    //   Cell: ({ row }) => {
    //     return booleanCell(row.original?.preventa_corporativa_data!.es_demo)
    //   }
    // },
    {
      accessorKey: 'tipo_plan',
      header: 'Tipo plan',
      filterVariant: 'select',
      filterSelectOptions: TIPO_PLAN_CORPORATIVO_CHOICE,
      Cell: ({ row }) => (
        row.original?.preventa_corporativa_data?.tipo_plan || "N/A"
      ),
    },
    // {
    //   accessorKey: 'preventa_corporativa_data.tipo_servicio',
    //   header: 'Tipo servicio',
    // },
    {
      accessorKey: 'coordenada_servicio',
      enableColumnFilter: false,
      header: 'Coordenada servicio',
      Cell: ({ row }) => <Button
        endIcon={<Visibility />}
        onClick={() => {
          infoCoordendas.handlePostInfoZone({
            latitud: row.original.preventa_corporativa_data?.coordenada_servicio.split(',').at(0)!,
            longitud: row.original.preventa_corporativa_data?.coordenada_servicio.split(',').at(1)!,
          }, row.original.preventa_corporativa_data?.sector!)
        }}>{row.original.preventa_corporativa_data?.coordenada_servicio}</Button>
    },
    {
      accessorKey: 'preventa_corporativa_data.direccion_servicio',
      enableColumnFilter: false,
      header: 'Direccion servicio'
    },
    {
      accessorKey: 'preventa_corporativa_data.coordenada_fusion',
      enableColumnFilter: false,
      header: 'Coordenada fusión'
    },
    {
      accessorKey: 'preventa_corporativa_data.direccion_fusion',
      enableColumnFilter: false,
      header: 'Direccion fusión'
    },
    {
      accessorKey: 'preventa_corporativa_data.coordenada_empresa',
      enableColumnFilter: false,
      header: 'Coordenada empresa'
    },
    {
      accessorKey: 'preventa_corporativa_data.direccion_empresa',
      enableColumnFilter: false,
      header: 'Direccion empresa'
    },
    {
      accessorKey: 'provincia_data.nombre',
      header: 'Provincia',
      Cell: ({ row }) => row.original?.provincia_data?.nombre || "N/A",
      enableColumnFilter: false,
    },
    {
      accessorKey: 'ciudad_data.nombre',
      header: 'ciudad',
      Cell: ({ row }) => row.original?.ciudad_data?.nombre || "N/A",
      enableColumnFilter: false,
    },
    {
      accessorKey: 'preventa_corporativa_data.celular_1',
      enableColumnFilter: false,
      header: 'Celular 1',
      Cell: ({ row }) => emptyCell(row.original.celular_1)
    },
    {
      accessorKey: 'preventa_corporativa_data.celular_2',
      enableColumnFilter: false,
      header: 'Celular 2',
      Cell: ({ row }) => emptyCell(row.original.celular_2)
    },
    {
      accessorKey: 'preventa_corporativa_data.tecnico_responsable',
      enableColumnFilter: false,
      header: 'Tecnico responsable',
    },
    {
      accessorKey: 'preventa_corporativa_data.email_tecnico_responsable',
      enableColumnFilter: false,
      header: 'Email tecnico responsable',
    },
    {
      accessorKey: 'preventa_corporativa_data.medio_ultima_milla',
      enableColumnFilter: false,
      header: 'Medio ultima milla',
    },
    // {
    //   accessorKey: 'preventa_corporativa_data.tipo_plan',
    //   enableColumnFilter:false,
    //   header: 'Tipo plan',
    // },
    {
      accessorKey: 'preventa_corporativa_data.tipo_backup',
      enableColumnFilter: false,
      header: 'Requiere Backup',
      Cell: ({ row }) => row.original?.preventa_corporativa_data?.requiere_backup ? "SI" : "NO"
    },
    {
      accessorKey: 'es_backup',
      header: 'Es Backup',
      filterVariant: 'select',
      filterSelectOptions: [
        { label: 'Principal', value: 'false' },
        { label: 'Backup', value: 'true' },
      ],
      Cell: ({ row }) => (
        <EstadoComponente
          backgroundColor={row.original?.es_backup ? '#FF9800' : '#4CAF50'}
          texto={row.original?.es_backup ? 'BACKUP' : 'PRINCIPAL'}
        />
      ),
    },
    // {
    //   accessorKey: 'preventa_corporativa_data.tipo_backup',
    //   enableColumnFilter:false,
    //   header: 'Tipo backup',
    // },
    {
      accessorKey: 'canal_venta_create',
      header: 'Canal venta',
      enableColumnFilter: false,
    },
    {
      accessorKey: 'user_create',
      header: 'Asesor',
      enableColumnFilter: false,
      Cell: ({ row }) => emptyCell(row.original?.prospecto_corporativo_data?.user_create)
    },
    {
      accessorKey: 'user_creador_preventa_data',
      header: 'Creador Preventa',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const creador = row.original?.user_creador_preventa_data;
        if (!creador) return "N/A";
        return creador.username || "N/A";
      }
    },
    {
      accessorKey: 'user_aprobador_prefactibilidad_data',
      header: 'Aprobador Prefactibilidad',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const aprobador = row.original?.user_aprobador_prefactibilidad_data;
        if (!aprobador) return "N/A";
        return aprobador.username || "N/A";
      }
    },
    {
      accessorKey: 'user_creador_factibilidad_data',
      header: 'Creador Factibilidad',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const creador = row.original?.user_creador_factibilidad_data;
        if (!creador) return "N/A";
        return creador.username || "N/A";
      }
    },
    {
      accessorKey: 'user_aprobador_factibilidad_data',
      header: 'Aprobador Factibilidad',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const aprobador = row.original?.user_aprobador_factibilidad_data;
        if (!aprobador) return "N/A";
        return aprobador.username || "N/A";
      }
    },

    {
      accessorKey: 'fecha_creacion',
      header: 'Fecha Creación',
      enableColumnFilter: false,
      Cell: ({ row }) => formatDate(row.original.fecha_creacion!)
    },
    {
      accessorKey: 'fecha_modificacion',
      header: 'Fecha Modificación',
      enableColumnFilter: false,
      Cell: ({ row }) => formatDate(row.original.fecha_modificacion!)
    },
  ];
    return cols.filter(col => !(hideEstadoFactibilidad && col.accessorKey === 'estado_factibilidad'));
  }, [hideEstadoFactibilidad]);

  return {
    columnsFactibilidad
  }

}